import React, { useState } from "react";
import "./industry.css";
import { Link, useNavigate } from "react-router-dom";

import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import Signupindustrynav from "./Signupindustrynav";
export default function Industrysignup() {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    confirmpassword: "",
    error: null,
    loading: false,
    who:"industry"

  });
  const navigate = useNavigate();
  const { name, email, password, confirmpassword, error, loading,who } = data;
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true,who:"industry" });
    if (!name || !email || !password || !confirmpassword) {
      setData({ ...data, error: "All fields are required" });
    }
    if (password !== confirmpassword) {
      setData({ ...data, error: "Password not matched" });
    }
    try {
      const result = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
        confirmpassword
      );
      await setDoc(doc(db, "Industry", result.user.uid), {
        uid: result.user.uid,
        name,
        email,
        who,
        createdAt: Timestamp.fromDate(new Date()),
        isOnline: true,
      });
      setData({
        name: "",
        email: "",
        password: "",
        confirmpassword: "",
        error: null,
        loading: false,
        who:"industry"
      });
      navigate("/industryform");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false,who:"industry" });
    }
  };
  return (
    <>
     <Signupindustrynav/>
     <div id="wrapper">
        <div className="form_div">
          <p className="form_label">COMPANY SIGNUP FORM</p>
          <form method="post" action="#" onSubmit={handleSubmit}>
            <p>   <input
              type="text"
              className="form-group w-100 p-2 inp"
              name="name"
              value={name}
              onChange={handleChange}
              placeholder="Company Name..."
              v-model="signup.user"
              required
            /></p>
            <p>
            <input
              type="email"
              name="email"
              value={email}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="email..."
              v-model="signup.email"
              required
            />
            </p>
            <p> <input
              type="password"
              name="password"
              value={password}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="password..."
              v-model="signup.pwd"
              required
            /></p>
            <p>
            <input
              type="password"
              name="confirmpassword"
              value={confirmpassword}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="confirm password..."
              v-model="signup.pwd"
              required
            />
            </p>
            {error ? <p className="error">{error}</p> : null}
            {/* <p><input type="submit" defaultValue="LOGIN" /></p> */}
            <button
              type="submit"
              className="btn w-75 btn-submit pr"
              required
              disabled={loading}
            >
              {loading ? "Creating ..." : "Register"}
            </button>
          </form>

          <p className="mt-2 dont">
            or have an account
            <Link
              to="/industrylogin"
              className="linksignup"
              title="open login page"
            >
              {" "}
              Login
            </Link>
          </p>
        </div>
        <br />
        <br />
        <br />
      </div>
     
    </>
  );
}


// bak bak kr rhe ye log
//nako